import * as React from 'react';

type Props = {
    children: React.ReactNode;
    ratio?: string;
};

const AspectRatio = ({ children, ratio = '72%' }: Props) => (
    <div
        style={{
            position: 'relative',
            width: '100%',
            height: '0',
            paddingTop: ratio,
        }}
    >
        <div
            style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
            }}
        >
            {children}
        </div>
    </div>
);

export default AspectRatio;
